// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__39pnE","validationTips":"StatementDescriptor_validationTips__1AOd8"};